<script lang="ts">
	import '../app.css';
	import { Toaster } from 'svelte-french-toast';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { user } from '$lib/stores/account';
	import mixpanel from 'mixpanel-browser';
	import { browser, dev } from '$app/environment';

	// Mixpanel tracking
	if (browser) {
		mixpanel.init('db8070872b5c2ee6bee3a7cd572fd2b9', {
			debug: dev,
			track_pageview: true,
			persistence: 'localStorage',
			api_host: '/mixpanel',
			ignore_dnt: true
		});
		if (dev) {
			mixpanel.disable();
		}
	}

	onMount(() => {
		// Google Analytics
		const script = document.createElement('script');
		script.src = 'https://www.googletagmanager.com/gtag/js?id=G-QM72H90GSN';
		script.async = true;
		document.head.appendChild(script);

		script.onload = () => {
			/* global dataLayer */
			window.dataLayer = window.dataLayer || [];
			function gtag() {
				dataLayer.push(arguments);
			}
			gtag('js', new Date());
			gtag('config', 'G-QM72H90GSN');
		};

		// Mixpanel
		if (typeof window !== 'undefined') {
			const unsubscribePage = page.subscribe(($page) => {
				mixpanel.track_pageview({ page: $page.url.pathname });
			});

			const unsubscribeUser = user.subscribe(($user) => {
				if ($user) {
					mixpanel.identify('' + $user.id);
				} else {
					mixpanel.reset();
				}
			});

			return () => {
				unsubscribePage();
				unsubscribeUser();
			};
		}
	});
</script>

<slot />

<Toaster />
